import { SelectProps } from 'antd';
import { useState } from 'react';
import { useDebounce } from '@/hooks';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import { ListManufacturersQuery } from '@/core/domain/operational/Manufacturers/Manufacturers.types';
import {
  useManufacturersDetailPublic,
  useManufacturersPublic,
} from '@/core/domain/stock/QuotationsOffers/QuotationsOffers.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: ListManufacturersQuery;
};

const ManufacturerInfiniteSelectFieldPublic: React.FC<Props> = ({
  queryFilter,
  ...props
}) => {
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const { data, isLoading, hasNextPage, fetchNextPage } =
    useManufacturersPublic({
      ...queryFilter,
      active: true,
      rows: 30,
      name: search,
    });

  const manufacturers = flatInfiniteData(data);

  const { data: detail } = useManufacturersDetailPublic(
    props.mode !== 'multiple' ? props.value : undefined,
  );

  const options =
    detail && !manufacturers?.find((item) => item.id === detail.id)
      ? [...(manufacturers || []), detail]
      : manufacturers;

  const manufacturerOptions = options.map((cur) => ({
    value: cur.id,
    label: cur.name,
  }));

  return (
    <InfiniteSelect
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      loading={isLoading}
      options={manufacturerOptions}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      {...props}
    />
  );
};

export default ManufacturerInfiniteSelectFieldPublic;
